export enum ListFilterBooking {
  All = 'all',
  MyBookings = 'my bookings',
}
